module.exports = __webpack_public_path__ + "img/17.dfa84729.jpeg";